module.exports = __webpack_public_path__ + "img/camera_pairing_mode.79e774b6.png";